import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';

export default class EmailCheck204SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-204';

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (emailCheckCode !== 204) {
      return false;
    }
    return true;
  }
}
